import axios from "axios";

import { ENDPOINT } from "../constant/environment";
import { decryptData, encryptData, getHeaderConfig } from "../utils/api/encryption";
import { consoleLog } from "../utils/consoleLog/consoleLog";
import { isValidJWT } from "../utils/authentication/isValidJWT";

export async function getItineraryDetailsAPI(id: string, accessJWT: string, abortController?: AbortController | null) {
  const URL = `${ENDPOINT}/app/v1/itineraries`;
  const body = {
    // id: "01c4d37b-0a7e-4af4-b549-678861fd1501",
    id: id,
  };
if (!accessJWT || !isValidJWT(accessJWT)) return null;
  let config;
  if (abortController) {
    config = getHeaderConfig(abortController.signal, accessJWT);
  } else {
    config = getHeaderConfig(null, accessJWT);
  }

  try {
    if (!accessJWT) return null;
    const response = await axios.post(URL, encryptData(body), config);
    if (response?.data) {
      const decryptedData = decryptData(response?.data);
      consoleLog(["RESPONSE ITINERARY", JSON.parse(decryptedData)]);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } else return null;
  } catch (error: any) {
    if (error.response && error.response.status === 409) {
    }
  }
}
